module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-300.408f909ba05bf9fac471.eot";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-300.eot
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-300.eot
// module chunks = styles